// Deterministic initials avatar for Kanban client cards.
// initials from business_name/contact_name/email, hue from the client id
// so the same customer keeps the same colour across renders.

export function initialsOf(client) {
  const src = (client.business_name || client.contact_name || client.email || "?").trim();
  const words = src.replace(/[^\w\s]/g, " ").split(/\s+/).filter(Boolean);
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  return src.slice(0, 2).toUpperCase();
}

export function avatarColor(client) {
  const src = client.id || client.email || client.business_name || "";
  let h = 0;
  for (let i = 0; i < src.length; i++) h = (h * 31 + src.charCodeAt(i)) % 360;
  return `hsl(${h}, 55%, 42%)`;
}

export function Avatar({ client }) {
  return (
    <div
      className="shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-[11px] font-bold text-white shadow-inner"
      style={{ backgroundColor: avatarColor(client) }}
      title={client.business_name || client.contact_name}
      data-testid={`client-avatar-${client.id}`}
    >
      {initialsOf(client)}
    </div>
  );
}
